import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import {
  PropertyRowCount,
  PropertyCountRequest
} from '../../../models/property-row-count.model';
import { environment } from '../../../environments/environments';


@Injectable({
  providedIn: 'root'
})
export class PropertyCountService {

  constructor(private http: HttpClient) {

  }

  /**
   * POST /api/tables/column-counts
   *
   * @param tableName logical name that ends in “…_de”
   * @param states    list of Bundesländer – pass ["total"] to include all
   */
  getPropertyCounts(
      tableName: string,
      states: string[] = ['total']
  ): Observable<PropertyRowCount[]> {

    const url = `${environment.apiUrl}/tables/column-counts`;

    const body: PropertyCountRequest = { tableName, states };

    return this.http.post<PropertyRowCount[]>(url, body).pipe(
        catchError(this.handleError)
    );
  }

  /* Swap for your global error interceptor if you have one */
  private handleError(err: HttpErrorResponse) {
    console.error('Property-count request failed', err);
    return throwError(() =>
        new Error(err.error?.message || 'Property-count request failed.'));
  }
}